import { render, staticRenderFns } from "./BtnAlternarContrato.vue?vue&type=template&id=56f27e61"
import script from "./BtnAlternarContrato.vue?vue&type=script&lang=js"
export * from "./BtnAlternarContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports